import {
  Checkbox,
  FormControlLabel,
  Grid,
  ListItemIcon,
  TableCell,
  TableRow,
  TextField,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Menu } from "@mui/icons-material";
import { useEffect, useState } from "react";
import DropdownComponent from "../../../../../App/Components/Dropdown/DropdownComponent";
import { RadiusID } from "../../../../../App/Enums/RadiusID";

const useStyles = makeStyles((theme) => ({
  rowCell: {
    cursor: "pointer !important",
    background: theme.palette.primary.blue,
    textDecoration: "none",
    "&:hover": {
      background: "rgba(0,0,0,.2) !important",
    },
  },
  rowCellOdd: {
    cursor: "pointer !important",
    background: "white",
    textDecoration: "none",
    "&:hover": {
      background: "rgba(0,0,0,.2) !important",
    },
  },

  itemIcon: {
    cursor: "grab",
  },
  tableCell: {
    color: theme.palette.primary.copy,
  },
}));

export default function StaticSearchFormTableCell(props) {
  const classes = useStyles(props);

  const [selectedSmall, setSelectedSmall] = useState("");
  const [selectedMedium, setSelectedMedium] = useState("");
  const [selectedLarge, setSelectedLarge] = useState("");
  const [selectedCustom, setSelectedCustom] = useState("");
  const [selected, setSelected] = useState(props.element.selected);

  useEffect(() => {
    if (props.element.searchPropertyAdminText === "Small Radius Collection") {
      setSelectedSmall(
        props.element.newRadius !== undefined
          ? props.element.newRadius
          : props.element.radiusCollections[RadiusID.Small][0]
      );
      props.element.newRadius =
        props.element.newRadius !== undefined
          ? props.element.newRadius
          : props.element.radiusCollections[RadiusID.Small][0];
      props.element.radiusCollections[RadiusID.Small].forEach((r) => {
        if (r.item1 === props.element.defaultRadius) {
          setSelectedSmall(r);
          props.element.newRadius = r;
          return;
        }
      });
    }
    if (props.element.searchPropertyAdminText === "Medium Radius Collection") {
      setSelectedMedium(
        props.element.newRadius !== undefined
          ? props.element.newRadius
          : props.element.radiusCollections[RadiusID.Medium][0]
      );
      props.element.newRadius =
        props.element.newRadius !== undefined
          ? props.element.newRadius
          : props.element.radiusCollections[RadiusID.Medium][0];
      props.element.radiusCollections[RadiusID.Medium].forEach((r) => {
        if (r.item1 === props.element.defaultRadius) {
          setSelectedMedium(r);
          props.element.newRadius = r;
          return;
        }
      });
    }
    if (props.element.searchPropertyAdminText === "Large Radius Collection") {
      setSelectedLarge(
        props.element.newRadius !== undefined
          ? props.element.newRadius
          : props.element.radiusCollections[RadiusID.Large][0]
      );
      props.element.newRadius =
        props.element.newRadius !== undefined
          ? props.element.newRadius
          : props.element.radiusCollections[RadiusID.Large][0];
      props.element.radiusCollections[RadiusID.Large].forEach((r) => {
        if (r.item1 === props.element.defaultRadius) {
          setSelectedLarge(r);
          props.element.newRadius = r;
          return;
        }
      });
    }
    if (props.element.searchPropertyAdminText === "Custom Radius Collection") {
      setSelectedCustom(
        props.element.newRadius !== undefined
          ? props.element.newRadius
          : props.element.radiusCollections[RadiusID.Custom][0]
      );
      props.element.newRadius =
        props.element.newRadius !== undefined
          ? props.element.newRadius
          : props.element.radiusCollections[RadiusID.Custom][0];
      props.element.radiusCollections[RadiusID.Custom].forEach((r) => {
        if (r.item1 === props.element.defaultRadius) {
          setSelectedCustom(r);
          props.element.newRadius = r;
          return;
        }
      });
    }
  }, [props.element]);

  function defaultRadius(func, index, val) {
    func(val);
    var temp = [...props.tableData];
    temp[index].newRadius = val;
    props.setTableData(temp);
  }

  function changeLabel(index, val) {
    var temp = [...props.tableData];
    temp[index].label = val;
    props.setTableData(temp);
  }

  function changePlaceholder(index, val) {
    var temp = [...props.tableData];
    temp[index].placeholder = val;
    props.setTableData(temp);
  }

  function changeSelected(index) {
    var temp = [...props.tableData];
    temp[index].selected = !temp[index].selected;
    setSelected(props.element.selected);
    props.setTableData(temp);
  }

  return (
    <>
      <TableRow
        hover
        className={props.index % 2 ? classes.rowCell : classes.rowCellOdd}
        key={props.index}
        ref={props.innerRef}
        {...props}
      >
        {props.columns.map((column, elementIndex) => (
          <TableCell
            align="left"
            key={elementIndex}
            className={classes.tableCell}
          >
            {column.label === "Selected" ? (
              <FormControlLabel
                style={{ marginTop: "10px" }}
                control={
                  <Checkbox
                    color="primary"
                    checked={props.element.selected}
                    onChange={() => changeSelected(props.index)}
                  />
                }
                label=""
              />
            ) : column.label === "Input Label" ? (
              <TextField
                placeholder="Input Label"
                label="Input Label"
                variant="standard"
                fullWidth
                style={{ minWidth: "100px" }}
                value={props.element.label}
                required
                error={selected && props.element.label === ""}
                onChange={(e) => changeLabel(props.index, e.target.value)}
              />
            ) : column.label === "Input Placeholder" ? (
              <TextField
                placeholder="Input Placeholder"
                label="Input Placeholder"
                variant="standard"
                fullWidth
                style={{ minWidth: "100px" }}
                value={props.element.placeholder}
                required
                error={selected && props.element.placeholder === ""}
                onChange={(e) => changePlaceholder(props.index, e.target.value)}
              />
            ) : column.label === "" ? (
              <ListItemIcon size="large" className={classes.itemIcon}>
                <Menu />
              </ListItemIcon>
            ) : (
              props.element[column.propName]
            )}
            {props.element[column.propName] === "Custom Radius Collection" ? (
              <Grid container spacing={1}>
                <Grid item xs={6} sm={6}>
                  <DropdownComponent
                    currValue={selectedCustom}
                    items={props.element.radiusCollections[RadiusID.Custom]}
                    property="item2"
                    title="Default"
                    handleChange={(value) =>
                      defaultRadius(setSelectedCustom, props.index, value)
                    }
                  />
                </Grid>
              </Grid>
            ) : props.element[column.propName] ===
              "Medium Radius Collection" ? (
              <Grid container spacing={1}>
                <Grid item xs={6} sm={6}>
                  <DropdownComponent
                    currValue={selectedMedium}
                    items={props.element.radiusCollections[RadiusID.Medium]}
                    property="item2"
                    title="Default"
                    handleChange={(value) =>
                      defaultRadius(setSelectedMedium, props.index, value)
                    }
                  />
                </Grid>
              </Grid>
            ) : props.element[column.propName] === "Small Radius Collection" ? (
              <Grid container spacing={1}>
                <Grid item xs={6} sm={6}>
                  <DropdownComponent
                    currValue={selectedSmall}
                    items={props.element.radiusCollections[RadiusID.Small]}
                    property="item2"
                    title="Default"
                    handleChange={(value) =>
                      defaultRadius(setSelectedSmall, props.index, value)
                    }
                  />
                </Grid>
              </Grid>
            ) : props.element[column.propName] === "Large Radius Collection" ? (
              <Grid container spacing={1}>
                <Grid item xs={6} sm={6}>
                  <DropdownComponent
                    currValue={selectedLarge}
                    items={props.element.radiusCollections[RadiusID.Large]}
                    property="item2"
                    title="Default"
                    handleChange={(value) =>
                      defaultRadius(setSelectedLarge, props.index, value)
                    }
                  />
                </Grid>
              </Grid>
            ) : null}
          </TableCell>
        ))}
      </TableRow>
    </>
  );
}
